<h1 mat-dialog-title>{{data.title? data.title : 'Message'}}</h1>
<div mat-dialog-content>
  {{data.message? data.message : 'Default message content.'}}
</div>
<div mat-dialog-actions>
  <button *ngIf="msg_type == 1"  mat-button mat-dialog-close>{{data.cancelText? data.cancelText : 'No'}}</button>
  <button  mat-button  [mat-dialog-close]="submitFlag" cdkFocusInitial>{{data.acceptText? data.acceptText : 'Yes'}}</button>
</div>